export default __webpack_public_path__ + "static/media/Arm-straps of the Crawling Chaos.8c5f2d43.jpg";